module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "liveliness",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "liveliness"
    }
  }, [_c('h3', [_vm._v("How lively is " + _vm._s(_vm.store.state.currentNeighborhood))]), _vm._v("\n  Venues per square mile (via Foursquare):\n  "), _c('div', {
    staticStyle: {
      "min-width": "960px",
      "max-width": "960px",
      "height": "400px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "venuesChart"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-397b4798!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Liveliness.vue
// module id = 177
// module chunks = 1